import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIRoutes } from "APIRoutes";
import axios from "utils/axios";
import { utils } from "utils/utils";

export interface CityDto {
  loading: boolean;
  data: any[];
}

export const getCities = createAsyncThunk("cities/getCities", async () => {
  const response: any = await axios.get(APIRoutes.CITIES);
  if (response.data?.statusCode) {
    utils.toastError(response.data?.message);
    return;
  }
  return { data: response?.data?.data ?? [] };
});

export const addNewCity = createAsyncThunk(
  "cities/addNewCity",
  async (data: any) => {
    const response: any = await axios.post(APIRoutes.CITIES, data);
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? [] };
  }
);

export const updateCity = createAsyncThunk(
  "cities/updateCity",
  async (data: any) => {
    const response: any = await axios.patch(
      `${APIRoutes.CITIES}/${data?.id ?? ""}`,
      data
    );
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? {} };
  }
);

export const deleteCity = createAsyncThunk(
  "cities/deleteCity",
  async (id: number) => {
    const response: any = await axios.delete(`${APIRoutes.CITIES}/${id}`);
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? {} };
  }
);

const initialState: CityDto = {
  loading: false,
  data: [],
};

export const cities = createSlice({
  name: "cities",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCities.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCities.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.data = payload?.data;
      })
      .addCase(getCities.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default cities.reducer;
